import { useEffect, useState } from 'react';
import isEmpty from 'lodash/isEmpty';
import { BRAND_JSON_URL } from '../lib/constants';

export function useBrandTrigger(enableBannerTriggerLogic: boolean) {
  /* eslint-disable @typescript-eslint/no-explicit-any */
  const [brandsData, setBrandsData] = useState<any>();

  useEffect(() => {
    (async () => {
      if (String(enableBannerTriggerLogic) === 'true' && isEmpty(brandsData)) {
        try {
          const response = await fetch(BRAND_JSON_URL, {
            method: 'GET',
          });
          const data = await response.json();
          setBrandsData(data);
        } catch (e) {
          setBrandsData({});
        }
      }
    })();
  }, []);

  return brandsData;
}
